import { MapPin } from "lucide-react";
import { MUNICIPIOS } from "../data/content";
import { useLang } from "../i18n";

const PINS = [
    { name: "Argentona", x: 30, y: 26 },
    { name: "Cabrils", x: 22, y: 38 },
    { name: "Premià de Dalt", x: 44, y: 42 },
    { name: "Vilassar de Dalt", x: 60, y: 34 },
    { name: "Alella", x: 18, y: 56 },
    { name: "El Masnou", x: 30, y: 66 },
    { name: "Premià de Mar", x: 46, y: 60 },
    { name: "Vilassar de Mar", x: 62, y: 54 },
    { name: "Mataró", x: 82, y: 46 },
];

const AreaMap = () => {
    const { t } = useLang();
    return (
        <div
            data-testid="area-map-container"
            className="relative overflow-hidden rounded-[2rem] border border-[#E3DCCF] bg-white shadow-sm"
        >
            <svg viewBox="0 0 100 100" className="block h-auto w-full" role="img" aria-label="Maresme">
                <path d="M0 0 H100 V34 Q78 20 60 30 Q42 40 26 30 Q12 22 0 32 Z" fill="#E2E8DE" />
                <path d="M0 32 Q12 22 26 30 Q42 40 60 30 Q78 20 100 34 V72 Q80 62 62 68 Q44 74 26 68 Q10 62 0 70 Z" fill="#F3ECDD" />
                <path d="M0 70 Q10 62 26 68 Q44 74 62 68 Q80 62 100 72 V100 H0 Z" fill="#D8E4DE" />
                <path d="M0 74 Q14 67 30 72 Q48 78 64 72 Q82 66 100 76" stroke="#9FBFB4" strokeWidth="0.7" fill="none" opacity="0.7" />
                <path d="M0 80 Q16 73 32 78 Q50 84 66 78 Q84 72 100 82" stroke="#9FBFB4" strokeWidth="0.5" fill="none" opacity="0.45" />
                <text x="74" y="90" fontSize="4.2" fontStyle="italic" fill="#5E7A70" fontFamily="Cormorant Garamond, serif">{t.map.sea}</text>
                <text x="6" y="12" fontSize="4.2" fontStyle="italic" fill="#4A5D3E" fontFamily="Cormorant Garamond, serif">{t.map.mountains}</text>
            </svg>

            {PINS.map((p) => (
                <div key={p.name} className="group absolute -translate-x-1/2 -translate-y-1/2" style={{ left: `${p.x}%`, top: `${p.y}%` }}>
                    <span className="relative flex h-3.5 w-3.5">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-terracotta opacity-30" />
                        <span className="relative inline-flex h-3.5 w-3.5 rounded-full border-2 border-white bg-terracotta shadow" />
                    </span>
                    <span className="pointer-events-none absolute left-1/2 top-full z-10 mt-1.5 -translate-x-1/2 whitespace-nowrap rounded-full bg-ink px-2.5 py-1 text-[10px] font-semibold text-cream opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                        {p.name}
                    </span>
                </div>
            ))}

            <div className="flex flex-wrap items-center gap-2 border-t border-[#E3DCCF] bg-cream/70 px-5 py-4">
                <MapPin size={15} className="text-terracotta" aria-hidden="true" />
                {MUNICIPIOS.map((m) => (
                    <span key={m} className="rounded-full bg-white px-3 py-1 text-[11px] font-semibold text-[#525B53] shadow-sm">
                        {m}
                    </span>
                ))}
                <span className="rounded-full bg-olive-light px-3 py-1 text-[11px] font-semibold text-olive-dark">{t.map.around}</span>
            </div>
        </div>
    );
};

export default AreaMap;
